import {useEffect, useState} from "react";
import {getClientByUniqueCode} from "../../services/Administrative/clientsService";

export const useGetClientByUniqueCode = (uniqueCode: string) => {
    const [client, setClient] = useState<any>(null);

    useEffect(() => {
        const fetchClientByUniqueCode = async () => {
            try {
                const response:any = await getClientByUniqueCode(uniqueCode);
                setClient(response);
            } catch (error) {
                console.error('Error fetching filters:', error);
            }
        };
        fetchClientByUniqueCode();
    }, [uniqueCode]);

    return { client };
}